import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['Sofía', 'Mateo', 'Valentina', 'Santiago', 'Camila', 'Sebastián', 'Isabella', 'Lucas', 'Martina', 'Nicolás', 'Lucía', 'Diego', 'Elena', 'Alejandro', 'Mariana', 'Felipe'];
const CITIES = ['Buenos Aires', 'Ciudad de México', 'Bogotá', 'Santiago', 'Lima', 'Montevideo', 'Córdoba', 'Medellín', 'Guadalajara', 'Rosario', 'Quito', 'Asunción'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
        // Schedule next notification (random between 8-15 seconds)
        const nextDelay = Math.floor(Math.random() * 7000) + 8000;
        setTimeout(showNotification, nextDelay);
      }, 4000);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  return <AnimatePresence data-id="element-8">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 right-4 z-50 bg-white rounded-lg shadow-xl p-4 max-w-xs border-l-4 border-[#2C5F2D] flex items-start gap-3" data-id="element-9">
          <div className="bg-[#E6F4EA] p-2 rounded-full flex-shrink-0" data-id="element-10">
            <CheckCircle className="w-5 h-5 text-[#2C5F2D]" data-id="element-11" />
          </div>
          <div data-id="element-12">
            <p className="text-sm font-bold text-gray-900" data-id="element-13">
              {data.name} de {data.city}
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-14">
              Acaba de comprar este libro digital
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-15">Hace unos segundos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}